<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'D' || row.orderStatus === 'T'
              ? 'danger'
              : row.orderStatus === 'R'
              ? 'warning'
              : row.orderStatus === 'Y' ||
                row.orderStatus === 'P' ||
                row.orderStatus === 'C'
              ? 'success'
              : 'light'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.orderCode },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:customerTime="{ row }">
        <span> NT：{{ row.customerNotificationTime }} </span>
        <br />
        <span> CT：{{ row.customerComfirmTime }} </span>
      </template>
      <template v-slot:submitInfo="{ row }">
        <span> {{ row.submitByName }} </span>
        <br />
        <span> {{ row.submitTime }} </span>
      </template>
      <template v-slot:reviewInfo="{ row }">
        <span> {{ row.reviewByName }} </span>
        <br />
        <span> {{ row.reviewTime }} </span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span> {{ row.createByName }} </span>
        <br />
        <span> {{ row.createTime }} </span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span> {{ row.modifyByName }} </span>
        <br />
        <span> {{ row.modifyTime }} </span>
      </template>
      <template v-slot:orderAmountInfo="{ row }">
        <span> {{ row.v_orderAmount }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:orderSalesAmountInfo="{ row }">
        <span> {{ row.v_orderSalesAmount }} {{ row.v_salesCurrencyUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'order-dashboard-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
